import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
// import { ModalQrcodeComponent } from '@modals/modal-qrcode/modal-qrcode.component';
import { EnumQRCodeType } from '@models/Common';
// import { IUserCard } from '@models/Wallet';
import { StringUtils } from '@utils/StringUtils';

@Component({
    selector: 'debit-card',
    templateUrl: './debit-card.component.html',
    styleUrls: ['./debit-card.component.scss'],
})
export class DebitCardComponent implements OnInit {

    @Input('data') Data: any// IUserCard;
    @Input('showToast') showToast: Function;

    public OnlyVirtual: boolean = true;

    constructor(private ModalController: ModalController) { }

    ngOnInit() {


        console.log(this.Data);

        this.OnlyVirtual = this.Data?.OnlyVirtual ?? true;
    }

    /**
     * copia numero do cartao (trim + remove espacos) para o clipboard
     * @param ev
     * @param text
     */
    public OnCopy(ev: any, text: string) {

        ev?.preventDefault();
        ev?.stopPropagation();

        const clip = StringUtils.ClipboardText(StringUtils.RemoveWhiteSpace(text));

        if (this.showToast && clip)
            this.showToast($localize`:@@toast.clipboard:Número copiado`)
    }
}
